import { render, staticRenderFns } from "./features.vue?vue&type=template&id=729c7015&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"
import style0 from "./features.vue?vue&type=style&index=0&id=729c7015&prod&scoped=true&lang=scss"
import style1 from "./features.vue?vue&type=style&index=1&id=729c7015&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c7015",
  null
  
)

export default component.exports